export const geoDiscountConfig = {
  US: { discount: 60, currency: 'USD', description: '60OFFUSD' },
  // IN: { discount: 67, currency: 'INR', description: 'BTSINDIA', coupon_code: 'BTSINDIA' },
  BR: { discount: 67, currency: 'BRL', description: '67OFFBRL' },
};

export const bannerMessages = {
  IN: 'Exclusive Back-to-School Offer — {discount}% Limited Coupons! Hurry Before They’re Gone',
  DEFAULT:
    'Exclusive Back-to-School Offer — {discount}% Limited Coupons! Hurry Before They’re Gone',
};
